import React, { Suspense } from "react";
import { Store } from "src/store";
import Providers from "src/providers";
import Modes from "src/modes/Modes";
import SuspenseFallbackModal from "src/modes/SuspenseFallbackModal";

interface Props {
    store: Store;
    ErrorBoundary: any;
    initialEntries?: [string];
}

const App = ({ store, ErrorBoundary, initialEntries }: Props) => {
    return (
        <Providers store={store} ErrorBoundary={ErrorBoundary} route={initialEntries}>
            <Suspense fallback={<SuspenseFallbackModal />}>
                <Modes />
            </Suspense>
        </Providers>
    );
};

export default App;
